import { forwardRef, RefObject, useEffect, useRef } from "react";
import { useReactToPrint } from "react-to-print";

import { Timeline } from "./timeline";
import { UserInfo } from "./user-info";
import { EventDetailRecord, EventRecord } from "../api/generated/landbot";
import { DefaultContentContainer } from "../layouts/default-content-container";

export const PrintableJourney: React.FC<{
  timeline: EventRecord[];
  userDetails: EventDetailRecord[];
  colors: string[];
}> = ({ timeline, userDetails, colors }) => {
  const timelineRef = useRef<HTMLDivElement | null>(null);
  useCtrlPToPrint(timelineRef);

  return (
    <DefaultContentContainer>
      <div ref={timelineRef}>
        <TimelineActionRow userDetails={userDetails} ref={timelineRef} />
        <Timeline colors={colors} timeline={timeline} />
      </div>
    </DefaultContentContainer>
  );
};

// eslint-disable-next-line react/display-name
const TimelineActionRow = forwardRef<
  HTMLDivElement,
  { userDetails: EventDetailRecord[] }
>(({ userDetails }, _ref) => {
  return (
    <div className="w-90 mx-auto mb-12 flex max-w-full flex-col items-center justify-center">
      <UserInfo userDetails={userDetails} />
    </div>
  );
});

const useCtrlPToPrint = (printRef: RefObject<HTMLDivElement | null>): void => {
  const print = useReactToPrint({ content: () => printRef.current });
  useEffect(() => {
    const listener = (event: DocumentEventMap["keydown"]): void => {
      if ((event.ctrlKey || event.metaKey) && event.keyCode === 80) {
        event.preventDefault();
        event.stopImmediatePropagation();
        print();
      }
    };
    document.addEventListener("keydown", listener, true);
    return () => document.removeEventListener("keydown", listener, true);
  }, [print]);
};
